<script lang="ts">
  import { cn } from '$lib/utils/tailwind';
  import { hubspotForm } from '$lib/actions/hubspot-form';
  import { HUBSPOT_API_PORTAL_ID, HUBSPOT_API_REGION } from '$lib/constants';

  import RegularFormSkeleton from '$components/skeletons/regular-form-skeleton.svelte';
  import NewsletterFormSkeleton from '$components/skeletons/newsletter-form-skeleton.svelte';

  export let form: string;
  export let skeleton: 'regular' | 'newsletter' = 'regular';
  let className: string | undefined = undefined;
  export { className as class };

  let isLoading = true;
</script>

<div class="h-full w-full">
  {#if form}
    {#if isLoading}
      {#if skeleton === 'newsletter'}
        <NewsletterFormSkeleton />
      {:else}
        <RegularFormSkeleton />
      {/if}
    {/if}

    <div
      id="hubspot-form-{form}"
      class={cn('w-full', className)}
      use:hubspotForm={{
        formId: form,
        region: HUBSPOT_API_REGION ? HUBSPOT_API_REGION : undefined,
        portalId: HUBSPOT_API_PORTAL_ID ? HUBSPOT_API_PORTAL_ID : undefined
      }}
      on:complete={() => {
        isLoading = false;
      }}
    />
  {/if}
</div>
